import React, { useEffect, useState } from 'react';
import { Row, Select, DatePicker, Button, Radio, Form, Input } from 'antd';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import IntlMessage from '../../../components/IntlMessage';
import destinationsApi from '../../../api/destinations';
import busOrdersApi from '../../../api/bus_orders';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { Option } = Select;
const SearchBus = (props) => {
  const [form] = Form.useForm();
  const [isOneWay, setIsOneWay] = useState(true);
  const [destinationFromOptions, setDestinationFromOptions] = useState([]);
  const [destinationToOptions, setDestinationToOptions] = useState([]);
  const [destinationFromId, setDestinationFromId] = useState(null);

  const { searchOrder, onFilter, justify, currentData, selectedRowKeys } =
    props;
  const intl = useIntl();
  useEffect(() => {
    if (currentData) {
      setDestinationFromId(
        currentData?.order_items[0]?.segment?.start_stop?.id,
      );
    }
  }, [currentData]);

  useEffect(() => {
    if (currentData) {
      console.log('set pax ', selectedRowKeys);
      form.setFieldValue('pax', selectedRowKeys.length);
    }
  }, [currentData, selectedRowKeys]);
  useEffect(() => {
    const fetch = async () => {
      const destination_from = await busOrdersApi.getFromDestination();
      const destination_to =
        await busOrdersApi.getToDestination(destinationFromId);

      if (destination_from) {
        setDestinationFromOptions(
          destination_from?.data.map((item, i) => {
            return {
              value: item.id,
              label: item.title,
            };
          }),
        );
      }

      if (destination_to) {
        setDestinationToOptions(
          destination_to?.data.map((item, i) => {
            return {
              value: item.id,
              label: item.title,
            };
          }),
        );
      }
    };
    fetch();
  }, [destinationFromId]);

  const handleSelectRoundTrip = () => {
    form.resetFields(['date']);
    setIsOneWay(!isOneWay);
  };
  const handleSelectDestinationFrom = (value) => {
    setDestinationFromId(value);
  };

  const handleSelectDestinationTo = (e) => {
    console.log(e);
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        searchOrder(values, isOneWay);
      })
      .catch((e) => console.log(e));
  };

  const handleChangePax = () => {};

  return (
    <>
      <Form
        layout="inline"
        form={form}
        onFinish={handleOk}
        initialValues={{
          from:
            currentData?.order_items[0]?.segment?.start_stop?.id ?? undefined,
          to: currentData?.order_items[0]?.segment?.end_stop?.id ?? undefined,
          date: currentData?.date ? dayjs(currentData.date) : null,
          pax: currentData?.qty ?? 1,
        }}
        name="control-hooks"
        style={{ maxWidth: 1000 }}>
        <Row type="flex" gutter={[16, 16]} justify={justify}>
          <Form.Item
            name={'from'}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Select
              style={{ minWidth: '150px' }}
              placeholder={intl.formatMessage({ id: 'placeholder.from' })}
              options={destinationFromOptions}
              onChange={handleSelectDestinationFrom}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>
          <Form.Item
            name={'to'}
            rules={[
              {
                required: true,
                message: <IntlMessage id="global.requiredfield" />,
              },
            ]}>
            <Select
              style={{ minWidth: '150px' }}
              placeholder={intl.formatMessage({ id: 'placeholder.to' })}
              options={destinationToOptions}
              onChange={handleSelectDestinationTo}
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '')
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            />
          </Form.Item>

          <>
            <Form.Item
              style={{ display: currentData ? 'none' : 'block' }}
              name="pax"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <Select
                onChange={handleChangePax}
                placeholder={intl.formatMessage({ id: 'global.passengers' })}
                style={{ minWidth: '150px' }}>
                {Array(5)
                  .fill(0)
                  .map((item, i) => {
                    return <Option value={i + 1}>{i + 1} Passengers</Option>;
                  })}
              </Select>
            </Form.Item>

            <Form.Item style={{ display: currentData ? 'none' : 'block' }}>
              <Button onClick={handleSelectRoundTrip} htmlType="button">
                {isOneWay ? (
                  <IntlMessage id="global.one_way" />
                ) : (
                  <IntlMessage id="global.two_way" />
                )}
              </Button>
            </Form.Item>
          </>

          {isOneWay ? (
            <Form.Item
              name="date"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <DatePicker
                format={'DD-MM-YYYY'}
                disabledDate={(current) => {
                  return current && current < dayjs().startOf('day');
                }}
              />
            </Form.Item>
          ) : (
            <Form.Item
              name="date"
              rules={[
                {
                  required: true,
                  message: <IntlMessage id="global.requiredfield" />,
                },
              ]}>
              <RangePicker
                placeholder={['Date', 'Date']}
                format={'DD-MM-YYYY'}
                style={{ width: '100%' }}
                disabledDate={(current) => {
                  let customDate = dayjs().format('YYYY-MM-DD');
                  return current && current < dayjs(customDate, 'YYYY-MM-DD');
                }}
                // onChange={handleRangeChange}
              />
            </Form.Item>
          )}
          <Button
            htmlType="submit"
            style={{ background: '#14bb8c', color: '#FFF', cursor: 'pointer' }}>
            Search
          </Button>
        </Row>
      </Form>
    </>
  );
};

SearchBus.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  textSearch: PropTypes.bool,
  onFilter: PropTypes.func,
  searchOption: PropTypes.object,
  justify: PropTypes.oneOf(['start', 'end', 'center', 'space-between']),
  showActionBar: PropTypes.bool,
  colTextSearch: PropTypes.number,
};

SearchBus.defaultProps = {
  data: [],
  onFilter: () => {},
  textSearch: true,
  searchOption: {},
  justify: 'start',
  showActionBar: true,
  colTextSearch: 6,
};

export default SearchBus;
